(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["droplit-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-mike-welcome-root]');
  if (!root) return;
  const dialog = root.querySelector('[data-mw-dialog]');
  const form = root.querySelector('#MikeWelcomeForm');
  const title = root.querySelector('#mw-title');
  const strings = JSON.parse(root.querySelector('[data-mw-strings]').textContent);
  const brand = root.dataset.welcomeBrand;
  const isCart = root.dataset.welcomeCart === 'true';
  if (isCart) root.querySelector('[data-mw-open]').hidden = true;
  const track = (name) => window.DroplitFunnel?.track(name, { source: brand });
  const key = 'droplit:welcome:' + brand + ':v2';
  const sharedKey = 'droplit:welcome:subscribed:v1';
  const offerKey = 'droplit:welcome:offer:v1';
  const allowedOffers = ['MIKE15', 'WELCOME15'];
  const incomingOffer = (new URLSearchParams(location.search).get('discount') || '').trim().toUpperCase();
  let welcomeOffer = allowedOffers.includes(incomingOffer) ? incomingOffer : '';
  try {
    if (welcomeOffer) sessionStorage.setItem(offerKey, welcomeOffer);
    else welcomeOffer = sessionStorage.getItem(offerKey) || '';
  } catch {}
  if (!allowedOffers.includes(welcomeOffer)) welcomeOffer = '';
  document.addEventListener('submit', event => {
    const checkoutForm = event.target;
    if (!welcomeOffer || !(checkoutForm instanceof HTMLFormElement) || !checkoutForm.querySelector('[name="checkout"]')) return;
    let discountInput = checkoutForm.querySelector('[name="discount"]');
    if (!discountInput) {
      discountInput = document.createElement('input');
      discountInput.type = 'hidden';
      discountInput.name = 'discount';
      checkoutForm.appendChild(discountInput);
    }
    discountInput.value = welcomeOffer;
  }, true);
  const subscribed = () => { if (welcomeOffer || dialog.dataset.subscriber === 'true') return true; try { return localStorage.getItem(sharedKey) === '1' || localStorage.getItem('droplit:mike-welcome:v1') === 'subscribed'; } catch { return dialog.dataset.subscriber === 'true'; } };
  const markSubscribed = () => { try { localStorage.setItem(sharedKey, '1'); } catch {} root.querySelector('[data-mw-open]').hidden = true; };
  const result = root.querySelector('[data-mw-result]').dataset.mwResult;
  let step = 'choice';
  let submitting = false;
  let returnFocus = null;
  const get = () => { try { return localStorage.getItem(key); } catch { return null; } };
  const save = value => { if (value === 'subscribed') markSubscribed(); try { localStorage.setItem(key, value); } catch {} };
  const showStep = next => {
    step = next;
    root.querySelectorAll('[data-mw-panel]').forEach(panel => { panel.hidden = panel.dataset.mwPanel !== next; });
    title.textContent = next === 'success' ? strings.successHeading : next === 'email' ? strings.emailHeading : strings.heading;
    root.querySelector('[data-mw-progress]').textContent = strings[next + 'Step'];
    if (dialog.open) title.focus({preventScroll:true});
  };
  const open = () => {
    if (isCart || dialog.open) return;
    returnFocus = document.activeElement;
    dialog.showModal();
    track('popup_viewed');
    title.focus({preventScroll:true});
  };
  dialog.addEventListener('close', () => {
    if (submitting) return;
    if (step !== 'success') track('popup_dismissed');
    save(step === 'success' ? 'subscribed' : 'dismissed');
    if (returnFocus?.isConnected && returnFocus !== document.body) returnFocus.focus({preventScroll:true});
  });
  root.querySelectorAll('[data-mw-close]').forEach(button => button.addEventListener('click', () => { submitting = false; dialog.close(); }));
  root.querySelector('[data-mw-open]').addEventListener('click', () => { showStep(get() === 'subscribed' ? 'success' : 'choice'); open(); });
  root.querySelectorAll('[data-mw-choice]').forEach(button => button.addEventListener('click', () => {
    root.querySelector('[data-mw-tags]').value = 'newsletter,welcome-source-' + brand + ',' + (brand === 'mike' ? 'mike-welcome,Mike/Kreteswell,' : '') + 'welcome-interest-' + button.dataset.mwChoice;
    showStep('email');
    root.querySelector('#MikeWelcomeEmail').focus({preventScroll:true});
  }));
  root.querySelector('[data-mw-back]').addEventListener('click', () => showStep('choice'));
  const returnPath = new URL(location.href);
  returnPath.searchParams.delete('customer_posted');
  returnPath.searchParams.delete('contact_posted');
  returnPath.searchParams.set('customer_posted', 'true');
  returnPath.hash = 'MikeWelcomeForm';
  form.querySelector('[name="return_to"]').value = returnPath.pathname + returnPath.search + returnPath.hash;
  form.addEventListener('submit', () => {
    track('signup_submitted');
    try { sessionStorage.setItem(key + ':pending', '1'); } catch {}
    submitting = true;
    if (dialog.matches(':modal')) { dialog.close(); dialog.show(); }
  });
  let pending = false;
  try { pending = sessionStorage.getItem(key + ':pending') === '1'; } catch {}
  if (location.hash === '#welcome-preview') {
    showStep('choice'); open();
  } else if (result === 'success' && pending) {
    track('signup_success');
    showStep('success'); save('subscribed'); open();
    try { sessionStorage.removeItem(key + ':pending'); } catch {}
  } else if (result === 'error') {
    track('signup_error');
    showStep('email'); open();
  } else if ((location.hash === '#mike-welcome' || location.hash === '#welcome') && !subscribed()) {
    showStep(get() === 'subscribed' ? 'success' : 'choice'); open();
  } else if (!isCart && brand !== 'pets' && !get() && !subscribed() && dialog.dataset.subscriber !== 'true') {
    window.setTimeout(() => {
      if (get() || subscribed() || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
      open();
    }, 3000);
  }
  if (subscribed() || dialog.dataset.subscriber === 'true') markSubscribed();
  window.addEventListener('storage', event => { if (event.key === sharedKey && event.newValue === '1') { root.querySelector('[data-mw-open]').hidden = true; if (dialog.open) dialog.close(); } });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mike-product-media"] && !Shopify.designMode) return;
  try {
    (() => {
 const init=()=>{
  const area=document.querySelector('.mike-photo-section');if(!area||area.dataset.ready)return;area.dataset.ready='1';
  const dialog=area.querySelector('.mike-photo-dialog'),large=area.querySelector('[data-photo-large]'),title=area.querySelector('#MikePhotoTitle');let opener,design;
  area.querySelectorAll('[data-mike-photo]').forEach(button=>button.addEventListener('click',()=>{opener=button;design=button.dataset.photoDesign;const photo=button.querySelector('img');large.src=button.dataset.photoUrl;large.alt=photo.alt;title.textContent=button.querySelector('span').textContent.replace('↗','').trim();dialog.showModal();}));
  area.querySelector('[data-photo-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  area.querySelector('[data-photo-choose]').addEventListener('click',()=>{dialog.close();const button=document.querySelector('[data-mike-gallery] [data-mike-design-id="'+design+'"]');if(button)button.click();else document.querySelector('#mike-designs')?.scrollIntoView({block:'start'});});
  const videos=[...document.querySelectorAll('[data-mike-films] video')];videos.forEach(v=>v.addEventListener('play',()=>videos.forEach(other=>{if(other!==v)other.pause();})));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(v=>v.pause());});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mike-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-mike-welcome-root]');
  if (!root) return;
  const dialog = root.querySelector('[data-mw-dialog]');
  const form = root.querySelector('#MikeWelcomeForm');
  const title = root.querySelector('#mw-title');
  const strings = JSON.parse(root.querySelector('[data-mw-strings]').textContent);
  const key = 'droplit:mike-welcome:v1';
  const result = root.querySelector('[data-mw-result]').dataset.mwResult;
  let step = 'choice';
  let submitting = false;
  let returnFocus = null;
  const get = () => { try { return localStorage.getItem(key); } catch { return null; } };
  const save = value => { try { localStorage.setItem(key, value); } catch {} };
  const showStep = next => {
    step = next;
    root.querySelectorAll('[data-mw-panel]').forEach(panel => { panel.hidden = panel.dataset.mwPanel !== next; });
    title.textContent = next === 'success' ? strings.successHeading : next === 'email' ? strings.emailHeading : strings.heading;
    root.querySelector('[data-mw-progress]').textContent = strings[next + 'Step'];
    if (dialog.open) title.focus({preventScroll:true});
  };
  const open = () => {
    if (dialog.open) return;
    returnFocus = document.activeElement;
    dialog.showModal();
    title.focus({preventScroll:true});
  };
  dialog.addEventListener('close', () => {
    if (submitting) return;
    save(step === 'success' ? 'subscribed' : 'dismissed');
    if (returnFocus?.isConnected && returnFocus !== document.body) returnFocus.focus({preventScroll:true});
  });
  root.querySelectorAll('[data-mw-close]').forEach(button => button.addEventListener('click', () => { submitting = false; dialog.close(); }));
  root.querySelector('[data-mw-open]').addEventListener('click', () => { showStep(get() === 'subscribed' ? 'success' : 'choice'); open(); });
  root.querySelectorAll('[data-mw-choice]').forEach(button => button.addEventListener('click', () => {
    root.querySelector('[data-mw-tags]').value = 'newsletter,mike-welcome,mike-interest-' + button.dataset.mwChoice;
    showStep('email');
    root.querySelector('#MikeWelcomeEmail').focus({preventScroll:true});
  }));
  root.querySelector('[data-mw-back]').addEventListener('click', () => showStep('choice'));
  const returnPath = new URL(location.href);
  returnPath.searchParams.delete('customer_posted');
  returnPath.searchParams.delete('contact_posted');
  returnPath.searchParams.set('customer_posted', 'true');
  returnPath.hash = 'MikeWelcomeForm';
  form.querySelector('[name="return_to"]').value = returnPath.pathname + returnPath.search + returnPath.hash;
  form.addEventListener('submit', () => {
    try { sessionStorage.setItem(key + ':pending', '1'); } catch {}
    submitting = true;
    if (dialog.matches(':modal')) { dialog.close(); dialog.show(); }
  });
  root.querySelector('[data-mw-copy]').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText('MIKE10');
      root.querySelector('[data-mw-copy-label]').textContent = strings.copied;
      root.querySelector('[data-mw-copy-status]').textContent = strings.copied;
    } catch {
      root.querySelector('[data-mw-copy-status]').textContent = strings.copyFailed;
    }
  });
  let pending = false;
  try { pending = sessionStorage.getItem(key + ':pending') === '1'; } catch {}
  if (result === 'success' && pending) {
    showStep('success'); save('subscribed'); open();
    try { sessionStorage.removeItem(key + ':pending'); } catch {}
  } else if (result === 'error') {
    showStep('email'); open();
  } else if (location.hash === '#mike-welcome') {
    showStep(get() === 'subscribed' ? 'success' : 'choice'); open();
  } else if (!get() && dialog.dataset.subscriber !== 'true') {
    window.setTimeout(() => {
      if (get() || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
      open();
    }, 1800);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
